goog.provide('el8.util.amplitude.dataExchangeHelpers');

goog.require('el8.util.amplitude.helpers');


/**
 * Log that the user clicked the 'Data Exchange' button
 * 
 */
el8.util.amplitude.logClickDataExchange = function () {
    el8.util.amplitude.logEvent('EHI - Click Data Exchange button');
};

/**
 * Log that the user clicked on one of the data exchange options
 * 
 * @param {string} functionName
 */
el8.util.amplitude.logViewDataExchangeFunction = function (functionName) {
    el8.util.amplitude.logEvent('EHI - View Data Exchange Function', {
        'function name': functionName,
    });
}